import React, { useState } from "react";
import del from "./images/icon-6.png";
import view from "./images/icon-7.png";
import job from "./images/icon-9.png";
import sub from "./images/icon-10.png";
import edit from "./images/icon-5.png";

import "select2";
import Skeleton from "react-loading-skeleton";
import AdminListService from "../../../services/admin-list.service";
import Pagination from "react-js-pagination";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import $ from "jquery";
import { useEffect } from "react";

export default function NewAccountantIndex({ id, setViewId }) {
  const [loading, setLoading] = useState(false);

  const [customerModelView, setCustomerModelView] = useState([]);

  const viewCustomerModelPagination = () => {
    const getPaginationData = async () => {
      setLoading(true);
      try {
        const responce = await AdminListService.viewCustomerInModel(id);

        let res;
        console.log(responce?.data.file?.file_details);

        if (responce.status === 200) {
          setCustomerModelView(responce?.data.file?.file_details);

          setLoading(false);
        }
      } catch (err) {
        console.log(err);
        setCustomerModelView([]);
        setLoading(false);
      }
    };
    getPaginationData();
  };

  useEffect(() => {
    if (id) {
      viewCustomerModelPagination(1);
    }
  }, [id]);
  const CustomerModelTable = ({ data }) => {
    return (
      <>
        <div className="table-responsive ">
          <table className="table table-striped align-middle w-100">
            <thead className="table-dark">
              <tr>
                <th>Cust Stor</th>
                <th>Bill-to Cust Number</th>
                <th>Inv #</th>
                <th>Inv Total</th>
                <th>Customer Name</th>
                <th>Address Line</th>
                <th>City</th>
                <th>St</th>
                <th>Zip Code</th>
                <th>Cell Phone</th>
                <th>Email Address</th>
                <th>Merchtotal</th>
              </tr>
            </thead>
            <tbody>
              {data.length ? (
                data.map((item) => (
                  <tr key={item.id}>
                    <td>{item.cust_stor}</td>
                    <td>{item.bill_to_cust_number}</td>
                    <td>{item.inv_number}</td>
                    <td>{item.inv_total}</td>
                    <td>{item.customer_name}</td>
                    <td>{item.address_line}</td>
                    <td>{item.city}</td>
                    <td>{item.state}</td>
                    <td>{item.zip_code}</td>
                    <td>{item.cell_phone}</td>
                    <td>{item.email_address}</td>
                    <td>{item.merch_total}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="12" align="center">
                    No Record Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </>
    );
  };

  return (
    <div
      className="modal fade"
      id="add_job_number"
      tabIndex="-1"
      aria-hidden="true"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
    >
      <div className="modal-dialog modal-xxl modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">File Data</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={() => {
                setViewId("");
              }}
            ></button>
          </div>
          <div className="modal-body">
            {loading ? (
              <Skeleton count={3} height="48px" />
            ) : (
              <CustomerModelTable data={customerModelView} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
